/**
 * PATH: apps/qa/src/pages/records-list/JobSearchResults.tsx
 * FILE_ID: QA-RECORDS-JOB-SEARCH-RESULTS-001
 * PURPOSE: List matching jobs above the inspections, including jobs with none.
 */
import { Loader2 } from 'lucide-react'
import type { Job } from '../new-inspection/inspection-types'

export function JobSearchResults({
  text,
  loading,
  failed,
  jobs,
  pendingJobId,
  onOpen,
}: {
  text: string
  loading: boolean
  failed: boolean
  jobs: Job[]
  pendingJobId: string | null
  onOpen: (jobNumber: string) => void
}) {
  if (!text) return null
  return (
    <section aria-label="Jobs" className="rounded-xl border border-border bg-card p-3">
      {loading ? <p className="text-sm text-muted-foreground">Searching jobs...</p> : null}
      {failed ? <p className="text-sm text-destructive">Job search failed.</p> : null}
      {jobs.length > 0 ? (
        <ul className="grid gap-2">
          {jobs.map((job) => {
            const number = job.job_number || String(job.job_id ?? '')
            if (!number || number === 'NaN') return null
            const title = (job.display_name || '').trim() || `Job ${number}`
            const client = typeof job.client === 'string' ? job.client : job.client?.name
            const site = typeof job.site === 'string' ? job.site : job.site?.name
            const subtitle = [`Job #${number}`, client, site].filter(Boolean).join(' · ')
            return (
              <li key={number} className="rounded-lg border border-border px-3 py-2">
                <p className="text-sm font-medium text-foreground">{title}</p>
                <p className="text-xs text-muted-foreground">{subtitle}</p>
                <button
                  type="button"
                  disabled={pendingJobId !== null}
                  onClick={() => onOpen(number)}
                  className="inline-flex items-center gap-2 text-sm font-medium text-primary text-left disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {pendingJobId === number && <Loader2 className="w-4 h-4 animate-spin" />}
                  Open job {number} QA
                </button>
              </li>
            )
          })}
        </ul>
      ) : null}
    </section>
  )
}
